module.exports = __webpack_public_path__ + "static/media/image5.d996b38a.jpg";